import {Component, OnInit} from '@angular/core';
import {AuthService} from "../../services/auth.service";
import {Router} from "@angular/router";
import {environment} from "../../../environments/environment";
import {Message, MessageService} from "primeng/api";
import {AppComponent} from "../../app.component";
import {Constants} from "../../types/constants";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  SSO_URL: string = environment.ssoUrl;
  message: Message[] = [
    {severity: "info",
      summary: "Zapraszamy do złożenia wniosku elektronicznego o wpis do Rejestru Pośredników Kredytowych UKNF.",
      closable: false
    }];
  loading: boolean = false;

  constructor(
    private router: Router,
    protected authService: AuthService,
    private messageService: MessageService) {
  }

  ngOnInit(): void {
    this.loading = false;
    if (this.authService.getToken())
      this.router.navigate(['/choose-form'])
  }

  login() {
    this.loading = true;
    this.authService.login().subscribe(
      (next) => {
        if (this.authService.authnRequest) {
          (document.getElementsByName("SAMLRequest")[0] as HTMLInputElement).value = this.authService.authnRequest;
          document.forms[0].submit();
        } else {
          this.messageService.add({
            severity: 'error',
            detail: Constants.GenericError }
          );
          this.loading = false;
        }
      },
      (error) => {
        this.messageService.add({
          severity: (error.status == 400 && error.error.message != Constants.GenericError) ? 'warn' : 'error',
          detail: error.error.message ?? Constants.GenericError}
        );
        this.loading = false;
      }
    )
  }

}
